import { useState } from "react"
import ReactModal from "react-modal"
import { Button } from "primereact/button"

export default function LogModal({ log }) {
  const [modalIsOpen, setIsOpen] = useState(false)

  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)

  let auditBody = log.audit_body
  try {
    auditBody = JSON.parse(auditBody)
  } catch (error) {
    console.error("Failed to parse audit_body:", error)
  }

  // Prettify the JSON content
  const prettifiedJson =
    typeof auditBody === "object"
      ? JSON.stringify(auditBody, null, 2)
      : auditBody

  return (
    <div>
      <Button label="View Details" onClick={openModal} />
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Log Details"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.75)",
          },
          content: {
            fontSize: "13px",
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            padding: "20px",
            maxWidth: "600px",
            width: "100%",
            background: "#fff",
            borderRadius: "8px",
          },
        }}
      >
        <h2>Log Details</h2>
        <div>
          <p>
            <strong>Type:</strong> {log.audit_record_type || "N/A"}
          </p>
          <p>
            <strong>Timestamp:</strong>{" "}
            {log.timestamp ? new Date(log.timestamp).toLocaleString() : "N/A"}
          </p>
          <p>
            <strong>Staff Facilitator:</strong>{" "}
            {log.audit_record_username || "N/A"}
          </p>
          <p>
            <strong>Audit Record URL:</strong>
            <a
              href={log.audit_record_url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {log.audit_record_url || "No URL provided"}
            </a>
          </p>
          <hr />
          <p>
            <strong>What changed?:</strong>
          </p>
          <div
            style={{
              background: "#333",
              color: "#C5E1A5",
              padding: "10px",
              borderRadius: "4px",
              fontFamily: "monospace",
              maxHeight: "280px",
              overflowY: "scroll",
            }}
          >
            <pre
              style={{ margin: 0, fontSize: "12px", whiteSpace: "pre-wrap" }}
            >
              {prettifiedJson}
            </pre>
          </div>
        </div>
        <Button label="Close" onClick={closeModal} style={{ marginTop: 15 }} />
      </ReactModal>
    </div>
  )
}
